import 'core-js/fn/array/includes'

import React from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'

import * as unitService from '../../services/organizational-units-service'
import * as scanService from '../../services/scan-service'

import Topbar from '../Topbar'
import ScoreBlock from './components/ScoreBlock'
import Bar from '../../components/Bar'
import Score from '../../components/Score'

export default class Overview extends React.Component {

  constructor(props, context) {
    super(props, context)

    this.filterChanged = this.filterChanged.bind(this)

    this.state = {
      units: [],
      currentColorFilter: ''
    }
  }

  filterChanged(color) {
    if (color === this.state.currentColorFilter) {
      color = ''
    }

    this.setState({
      currentColorFilter: color
    })
  }

  componentDidMount() {
    unitService.getUnitsWithScores().then(
      (units) => this.setState({ units })
    )
  }

  rowClicked(row) {
    if (row && row.score) {
      scanService.getMostRecentCompletedScan(row.id).then((scanDTO) => {
        this.props.history.push(`/results/${scanDTO.id}`)
      })
    } else if( row && row.score === null && row.lastScanID !== null ){
      this.props.history.push(`/scans/${row.lastScanID}/next`)
    } else {
      this.props.history.push('/newscan')
    }
  }

  getTable(units, columns, rowEvents) {
    const paginationOptions = paginationFactory({
      sizePerPageList: [{
        value: 20
      }],
      paginationSize: 5,
      hideSizePerPage: true,
      alwaysShowAllBtns: true
    })

    return (
      <div>
      {(!units || units.length === 0) ? (
        <div className="no-results"><p>Geen resultaten</p></div>
      ) : (
        <BootstrapTable
          keyField='id'
          data={units}
          columns={columns}
          bordered={ false }
          striped
          hover
          condensed
          pagination={paginationOptions}
          rowEvents={rowEvents} />
      )}
    </div>)
  }

  render() {
    const { units, currentColorFilter} = this.state
    const unitsGreen = units.filter((u) => u.score !== null && u.score >= 0)
    const unitsRed   = units.filter((u) => u.score < 0)
    const unitsGrey  = units.filter((u) => u.score === null)

    function headerFormatter(column, colIndex, { sortElement }) {
      return (
        <span className="sortable-inner">
          <span className="text">{column.text}</span>
          {sortElement}
        </span>
      )
    }

    function contentFormatter(cell, row) {
      return (
        <span className="text">{cell}</span>
      )
    }

    function scoreFormatter(cell, row) {
      return (
        <span className="text"><Bar score={cell} /><Score score={cell} /></span>
      )
    }

    function scoreHeader() {
      let filterText = ''
      if (currentColorFilter === 'red') {
        filterText = '(alleen negatieve scores)'
      } else if (currentColorFilter === 'green') {
        filterText = '(alleen positieve scores)'
      } if (currentColorFilter === 'grey') {
        filterText = '(alleen zonder score)'
      }

      return 'Score ' + filterText
    }

    const columns = [{
      dataField: 'locationName',
      text: 'Locatie',
      sort: true,
      headerFormatter: headerFormatter,
      formatter: contentFormatter
    }, {
      dataField: 'name',
      text: 'Organisatorische eenheid',
      sort: true,
      headerFormatter: headerFormatter,
      formatter: contentFormatter
    }, {
      dataField: 'score',
      text: scoreHeader(),
      sort: true,
      headerFormatter: headerFormatter,
      formatter: scoreFormatter, // let op dit is bewust 1 gecombineerde kolom, zie Jira
      sortFunc: (a, b, order, dataField) => {
        if (order === 'asc') {
          return b - a;
        }
        return a - b; // desc
      }
    }]

    const rowEvents = {
      onClick: (e, row, rowIndex) => {
        this.rowClicked(row)
      }
    }

    return (
      <div className="content table-page dashboard">
        <div className="content-inner">
          <Topbar title="Overzicht" />

          <div className="inner">
            <div className="block">
              <ScoreBlock score={unitsGreen.length} text="Aantal eenheden dat &lsquo;voldoende&rsquo; brandveiligheid heeft gescoord." color='green' callback={this.filterChanged} />
              <ScoreBlock score={unitsRed.length} text="Aantal eenheden dat &lsquo;onvoldoende&rsquo; brandveiligheid heeft gescoord." color='red' callback={this.filterChanged} />
              <ScoreBlock score={unitsGrey.length} text="Aantal eenheden in BrandWijzer dat nog geen (voltooide) scan heeft." color='grey' callback={this.filterChanged} />
              <div className="filter-block-container text">
                De vierkanten hiernaast tonen het aantal organisatorische eenheden dat voldoende of onvoldoende brandveilig heeft gescoord of nog geen score heeft. Klikken op een vierkant toont in de lijst eronder om welke organisatorische eenheden het gaat.
              </div>
            </div>

            {currentColorFilter === '' && this.getTable(units, columns, rowEvents)}
            {currentColorFilter === 'green' && this.getTable(unitsGreen, columns, rowEvents)}
            {currentColorFilter === 'red' && this.getTable(unitsRed, columns, rowEvents)}
            {currentColorFilter === 'grey' && this.getTable(unitsGrey, columns, rowEvents)}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Overview/index.js